export const PROFILE_UPDATED = 'Profile updated';
export const PROFILE_DELETED = 'Profile deleted';
export const PROFILE_CREATED = 'Profile created';
